"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRTCConnectionProxy = void 0;
/* functions that actually used:

new
getConnectionId
channelIsOperational
close
setMessageCallback
answer
receiveSignallingMessage

*/
class WebRTCConnectionProxy {
    constructor(local, remote, callId, readyCallback, commandForwardingFn) {
        this.commandForwardingFn = commandForwardingFn;
        this.localAddress = local;
        this.remoteAddress = remote;
        this.initiator = false;
        this.callId = callId;
        this.readyCallback = readyCallback;
        this.cachedChannelStatus = 'unknown';
        this.closed = false;
        this.lastKnownBufferedAmount = 0;
        this.connectionEventIngestFn = (ev) => {
            if (ev.connId === this.callId) {
                if (ev.type === 'connection-ready') {
                    this.readyCallback(this);
                }
                else if (ev.type === 'connection-status-change') {
                    const change = ev;
                    this.cachedChannelStatus = change.status;
                }
                else if (ev.type === 'message-received') {
                    const msg = ev;
                    // this check should be unnecessary, because the WebRTCConnectionProvider
                    // won't start forwarding messages until it has been informed by this class
                    // that the messageCallback was installed.
                    if (this.messageCallback !== undefined) {
                        this.messageCallback(msg.data, this);
                    }
                    else {
                        console.log('WARNING: lost message due to missing callback in WebRTCConnectionProxy for ' + msg.connId);
                    }
                }
                else if (ev.type === 'update-buffered-amount') {
                    const msg = ev;
                    this.lastKnownBufferedAmount = msg.bufferedAmount;
                }
            }
        };
        const msg = {
            type: 'create-connection',
            connId: callId,
            localEndpoint: local.url(),
            remoteEndpoint: remote.url()
        };
        this.commandForwardingFn(msg);
    }
    getConnectionId() {
        return this.callId;
    }
    initiatedLocally() {
        throw new Error('Method not implemented.');
    }
    setMessageCallback(messageCallback) {
        this.messageCallback = messageCallback;
        if (messageCallback !== undefined) {
            const cmd = {
                type: 'message-callback-set',
                connId: this.callId
            };
            this.commandForwardingFn(cmd);
        }
    }
    // possible values: 'unknown', 'connecting', 'open', 'closed', 'closing';
    channelStatus() {
        return this.cachedChannelStatus;
    }
    channelIsOperational() {
        return this.cachedChannelStatus === 'open';
    }
    open(channelName = 'mesh-network-channel') {
        const cmd = {
            type: 'open-connection',
            connId: this.callId,
            channelName: channelName
        };
        this.commandForwardingFn(cmd);
    }
    answer(message) {
        const cmd = {
            type: 'answer-connection',
            connId: this.callId,
            message: message
        };
        this.commandForwardingFn(cmd);
    }
    receiveSignallingMessage(message) {
        const cmd = {
            type: 'receive-signalling',
            connId: this.callId,
            message: message
        };
        this.commandForwardingFn(cmd);
    }
    close() {
        this.closed = true;
        const cmd = {
            type: 'close-connection',
            connId: this.callId
        };
        this.commandForwardingFn(cmd);
    }
    send(message) {
        const cmd = {
            type: 'send-message',
            connId: this.callId,
            contents: message
        };
        this.commandForwardingFn(cmd);
    }
    bufferedAmount() {
        return this.lastKnownBufferedAmount;
    }
}
exports.WebRTCConnectionProxy = WebRTCConnectionProxy;
//# sourceMappingURL=WebRTCConnectionProxy.js.map